export const slideShowContainer = {
  width: '100vw',
  height: '100vh',
  overflowY: 'scroll',
  backgroundColor: 'rgba(0,0,0,0.5)',
  top: 0,
  userSelect: 'none',
};
export const contentContainerStyle = {
  margin: '0 auto',
  marginTop: 40,
  width: '1000px',
};
export const slideShowBodyStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
};

export const imageStyle = {
  padding: 32,
  border: '1.7px solid rgb(20,20,20)',
  backgroundColor: 'white',
  minWidth: '100%',
  height: '73vh',
  overflowY: 'scroll',
  marginBottom: 100,
};
export const closeButtonStyle = {
  fontSize: 18,
  zIndex: 1000,
  color: `rgb(10,10,10)`,
  cursor: 'pointer',
};
export const buttonStyle = {
  zIndex: 1000,
  color: `rgb(10,10,10)`,
  backgroundColor: 'none',
  margin: 10,
  padding: '5px 20px',
  borderRadius: 500,
  fontSize: 20,
  height: 58,
  width: 60,
  textAlign: 'center',
  verticalAlign: 'center',
  cursor: 'pointer',
};
